'use client'

import { Dialog } from '@vinted/web-ui'

import { partiesHaveMet } from '@marketplace-web/conversation-shipping/conversation-shipping-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { reloadPage } from '@marketplace-web/shared/browser-util'

type Props = {
  transactionId: number
  isOpen: boolean
  onClose: () => void
}

const WeHaveMetConfirmationModal = ({ transactionId, isOpen, onClose }: Props) => {
  const translate = useTranslate('conversation.actions.we_have_met.modal')

  async function handleWeHaveMetClick() {
    await partiesHaveMet(transactionId)
    onClose()
    reloadPage()
  }

  return (
    <Dialog
      show={isOpen}
      defaultCallback={onClose}
      title={translate('title')}
      body={translate('body')}
      actions={[
        {
          text: translate('button'),
          callback: handleWeHaveMetClick,
          style: Dialog.ActionStyling.Filled,
        },
        {
          text: translate('close'),
          callback: onClose,
          style: Dialog.ActionStyling.Flat,
        },
      ]}
    />
  )
}

export default WeHaveMetConfirmationModal
